import { render, staticRenderFns } from "./SmallLoadingLogo.vue?vue&type=template&id=10c03f4e&scoped=true&"
import script from "./SmallLoadingLogo.vue?vue&type=script&lang=js&"
export * from "./SmallLoadingLogo.vue?vue&type=script&lang=js&"
import style0 from "./SmallLoadingLogo.vue?vue&type=style&index=0&id=10c03f4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c03f4e",
  null
  
)

export default component.exports